import { Navigate, type RouteObject } from 'react-router';
import { lazyComponent } from '@/platform/lazyComponent';
import { Require } from '@/platform/Require';

const AccountPage = lazyComponent(() => import('./account/AccountPage').then((module) => module.AccountPage));
const AppsPage = lazyComponent(() => import('./apps/AppsPage').then((module) => module.AppsPage));
const ReportsPage = lazyComponent(() => import('./reports/ReportsPage').then((module) => module.ReportsPage));
const SeasonDetailPage = lazyComponent(() => import('./sports/SeasonDetailPage').then((module) => module.SeasonDetailPage));
const SeasonsPage = lazyComponent(() => import('./sports/SeasonsPage').then((module) => module.SeasonsPage));
const SportLayout = lazyComponent(() => import('./sports/SportLayout').then((module) => module.SportLayout));
const SportListTab = lazyComponent(() => import('./sports/SportListTab').then((module) => module.SportListTab));
const SportSeasonsTab = lazyComponent(() => import('./sports/SportSeasonsTab').then((module) => module.SportSeasonsTab));
const SportsPage = lazyComponent(() => import('./sports/SportsPage').then((module) => module.SportsPage));

/** Base's own pages. The settings pages and each module's reports are added by the modules themselves (see `platform/modules.ts`). */
export const baseRoutes: RouteObject[] = [
  // Anyone signed in may open their own account settings: it needs no permission.
  { path: 'account', element: <AccountPage /> },
  { path: 'apps', element: <Require permission="app.manage"><AppsPage /></Require> },
  { path: 'reports', element: <Require permission="report.generate"><ReportsPage /></Require> },
  // Sports, and inside one sport its details and related lists. Teams is added by Athletes (`routeExtensions` under the route id `sport`).
  { path: 'sports', element: <Require permission="sport.manage"><SportsPage /></Require> },
  {
    id: 'sport',
    path: 'sports/:sportId',
    element: <Require permission="season.view"><SportLayout /></Require>,
    children: [
      { index: true, element: <Navigate to="seasons" replace /> },
      { path: 'seasons', element: <SportSeasonsTab /> },
      { path: 'positions', element: <SportListTab kind="positions" /> },
    ],
  },
  { path: 'seasons', element: <Require permission="season.view"><SeasonsPage /></Require> },
  { path: 'seasons/:seasonId', element: <Require permission="season.view"><SeasonDetailPage /></Require> },
];
